export const DICE_TYPES = ['d4', 'd6', 'd8', 'd10', 'd12', 'd20', 'd100', 'df'] as const;
export type DiceType = (typeof DICE_TYPES)[number];

export const DICE_SIDES: Record<DiceType, number> = {
    d4: 4,
    d6: 6,
    d8: 8,
    d10: 10,
    d12: 12,
    d20: 20,
    d100: 100,
    df: 3, // internally 1=−, 2=□, 3=+; never explodes
};

export type DiceConfig = {
    exploding: boolean;
};

export const DEFAULT_DICE_CONFIG: DiceConfig = {
    exploding: false,
};

export const ROOM_MODE_OPTIONS = [
    { value: 'brio', label: 'Sistema Brío' },
    { value: 'only-dice', label: 'Solo dados' },
] as const;

export type RoomMode = (typeof ROOM_MODE_OPTIONS)[number]['value'];

export const DEFAULT_ROOM_MODE: RoomMode = 'brio';

export function isRoomMode(value: string | null): value is RoomMode {
    return value === 'brio' || value === 'only-dice';
}
